import { createContext } from 'react'

const DataElementsContext = createContext(null)

export default DataElementsContext
